// Shared content for the Service Processing Notice (card + modal)
export const noticeContent = {
  en: {
    badge: "Important Notice",
    title: "Service Processing Time and Fee",
    intro:
      "We are committed to providing accurate, professional, and timely services to all of our clients. Please be advised that standard processing times for most services may take approximately 5 to 7 business days from the date all required documents, information, and applicable fees have been received. Processing times may vary depending on the complexity of the request, third-party requirements, government agencies, or other circumstances beyond our control.",
    standardLabel: "Standard processing",
    standardValue: "5\u20137 business days",
    subtitle: "Rush Service Requests",
    bullets: [
      "Rush services are subject to availability and acceptance by Nina Latinos Multi Services LLC.",
      "An additional rush processing fee will apply to all expedited requests.",
      "Rush services do not guarantee same-day completion.",
      "Expedited requests generally require 24 to 48 hours for completion.",
      "Certain rush requests may require up to 72 hours, depending on the nature and complexity of the service, document requirements, and agency processing times.",
    ],
    footer: "Thank you from Nina Latinos Multi Services, LLC",
    close: "Got it",
  },
  es: {
    badge: "Aviso Importante",
    title: "Plazos de tramitaci\u00f3n y tarifas del servicio",
    intro:
      "Nos comprometemos a ofrecer servicios precisos, profesionales y oportunos a todos nuestros clientes. Le informamos que los plazos est\u00e1ndar de tramitaci\u00f3n para la mayor\u00eda de los servicios pueden oscilar entre 5 y 7 d\u00edas h\u00e1biles, contados a partir de la fecha en que se reciban todos los documentos e informaci\u00f3n requeridos, as\u00ed como las tarifas correspondientes. Estos plazos pueden variar seg\u00fan la complejidad de la solicitud, los requisitos de terceros, los procedimientos de organismos gubernamentales u otras circunstancias ajenas a nuestro control.",
    standardLabel: "Tramitaci\u00f3n est\u00e1ndar",
    standardValue: "5\u20137 d\u00edas h\u00e1biles",
    subtitle: "Solicitudes de servicio urgente",
    bullets: [
      "Los servicios urgentes est\u00e1n sujetos a disponibilidad y a la aceptaci\u00f3n por parte de Nina Latinos Multi Services LLC.",
      "Se aplicar\u00e1 una tarifa adicional por tramitaci\u00f3n urgente a todas las solicitudes aceleradas.",
      "Los servicios urgentes no garantizan la finalizaci\u00f3n el mismo d\u00eda.",
      "Por lo general, las solicitudes aceleradas requieren entre 24 y 48 horas para completarse.",
      "Ciertas solicitudes urgentes pueden requerir hasta 72 horas, dependiendo de la naturaleza y complejidad del servicio, los requisitos de documentaci\u00f3n y los tiempos de tramitaci\u00f3n de los organismos correspondientes.",
    ],
    footer: "Atentamente, Nina Latinos Multi Services, LLC",
    close: "Entendido",
  },
};

export default noticeContent;
